import { useEffect, useState } from 'react'
import { match } from 'ts-pattern'

import { combineURLSearchParams } from '../Helpers/combineURLSearchParams'
import { mapKeyValueArrayToObject } from '../Helpers/mapKeyValueArrayToObject'

export type CombinationOfMtmParams =
  | 'Use CTA MTMs only'
  | 'Use page MTMs only'
  | 'Combine both'
  | null
  | undefined

export type MtmParams =
  | {
      value: { key: string; value: string }[]
    }
  | null
  | undefined

const getMTMString = (params: URLSearchParams): string =>
  params?.toString() ? `?${params.toString()}` : ''

export const useMTMParams = (
  combination_of_mtm_params: CombinationOfMtmParams,
  ctaMtmParams: MtmParams
): string => {
  const [resultMTMs, setResultMTMs] = useState('')

  useEffect(() => {
    const ctaMTM = ctaMtmParams?.value?.length
      ? new URLSearchParams(mapKeyValueArrayToObject(ctaMtmParams.value))
      : new URLSearchParams()
    const locationSearch =
      typeof window !== 'undefined' && window.location && window.location.search
        ? new URLSearchParams(window.location.search)
        : new URLSearchParams()

    const mtmString = match<CombinationOfMtmParams>(combination_of_mtm_params)
      .with('Use CTA MTMs only', () => getMTMString(ctaMTM))
      .with('Use page MTMs only', () => getMTMString(locationSearch))
      .with('Combine both', () => {
        const combinedParams = combineURLSearchParams(ctaMTM, locationSearch)
        return getMTMString(combinedParams)
      })
      .with(null, () => '')
      .with(undefined, () => '')
      .exhaustive()

    setResultMTMs(mtmString)
  }, [combination_of_mtm_params, ctaMtmParams])

  return resultMTMs
}
